import React from 'react';

import { BREAKPOINTS } from '@clutter/clean';

import { ResponsiveImage } from '@shared/responsive_image';

import { IResponsiveImage } from '@utils/images';

const SIZES = `(min-width: ${BREAKPOINTS.XL}) 550px, (min-width: ${BREAKPOINTS.MD}) 40vw, 100vw`;

export const SizedResponsiveImage: React.FC<{
  image: IResponsiveImage;
  alt: string;
}> = ({ image, alt }) => (
  <ResponsiveImage image={image} sizes={SIZES} alt={alt} />
);
